// src/api/productoServicio.js
import { apiFetch } from './index.js';

export const obtenerProductoServicios = async () => {
  try {
    const response = await apiFetch('/Productoservicio');
    const data = Array.isArray(response) ? response : (response.data || []);

    return {
      success: true,
      data: data.map(ps => ({
        idProductoServicio: ps.idProductoServicios || ps.idProductoServicio || ps.id,
        codigo: ps.codigo,
        nombre: ps.nombre,
        descripcion: ps.descripcion || '',
        estado: ps.estado || 'activo'
      }))
    };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerProductoServicioPorId = async (id) => {
  try {
    const response = await apiFetch(`/Productoservicio/${id}`);
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const crearProductoServicio = async (data) => {
  try {
    const response = await apiFetch('/Productoservicio', {
      method: 'POST',
      body: {
        codigo: data.codigo.trim(),
        nombre: data.nombre.trim(),
        descripcion: data.descripcion || '',
        estado: data.estado || 'activo'
      }
    });
    return { success: true, data: response, message: 'Producto/Servicio creado' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const actualizarProductoServicio = async (id, data) => {
  try {
    const response = await apiFetch(`/Productoservicio/${id}`, {
      method: 'PUT',
      body: {
        idProductoServicio: parseInt(id),
        codigo: data.codigo.trim(),
        nombre: data.nombre.trim(),
        descripcion: data.descripcion || '',
        estado: data.estado || 'activo'
      }
    });
    return { success: true, data: response, message: 'Producto/Servicio actualizado' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const eliminarProductoServicio = async (id) => {
  try {
    await apiFetch(`/Productoservicio/${id}`, { method: 'DELETE' });
    return { success: true, message: 'Producto/Servicio eliminado' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
